import { UntypedFormGroup } from '@angular/forms';
import { Directive, OnDestroy, TemplateRef } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { Observable, Subscription } from 'rxjs';

@Directive()
export abstract class AuthBaseDirective implements OnDestroy {
  error: string | null;
  loading = false;
  formValueSubscription: Subscription;

  onChanges(form: UntypedFormGroup): void {
    this.formValueSubscription = form.valueChanges.subscribe((val) => {
      this.error = null;
    });
  }

  protected submitWithLoading(
    request$: Observable<unknown>,
    dialogService: NbDialogService,
    dialog: TemplateRef<unknown>,
  ) {
    this.loading = true;
    request$.subscribe(
      () => {
        dialogService.open(dialog, { closeOnBackdropClick: false });
        this.loading = false;
      },
      (err: { error: { message: string } }) => {
        this.error = err.error.message;
        this.loading = false;
      },
    );
  }

  ngOnDestroy(): void {
    this.formValueSubscription?.unsubscribe();
  }
}
